import {
  LOAD_ACCOUNT,
  LOAD_ACCOUNT_DATA,
  LOAD_ACCOUNT_DATA_FAILURE,
  CLOSE_ACCOUNT_NUMBER_CHANGE_FORM_ERROR,
  CLOSE_ACCOUNT_NUMBER_CHANGE_FORM_MODAL,
  OPEN_ACCOUNT_NUMBER_CHANGE_FORM_MODAL,
  ACCOUNT_NUMBER_CHANGE_CLEAR_REQUEST,
  GET_ACCOUNTS_REQUEST,
  GET_ACCOUNTS_SUCCESS,
  GET_ACCOUNTS_FAILURE,
  CLEAR_ACCOUNT_REQUEST,
  OPEN_UNLINK_FORM_MODAL,
  CLOSE_UNLINK_FORM_MODAL,
  UNLINK_ACCOUNT_FORM_REQUEST,
  UNLINK_ACCOUNT_FORM_SUCCESS,
  UNLINK_ACCOUNT_FORM_FAILURE,
  OPEN_UPDATE_DUAL_FORM_STATUS_MODAL,
  CLOSE_UPDATE_DUAL_FORM_STATUS_MODAL,
  REQUEST_UPDATE_DUAL_FORM_STATUS,
  RECIEVE_UPDATE_DUAL_FORM_STATUS,
  UPDATE_DUAL_FORM_STATUS_FAILURE,
  SAVE_ACCOUNT_COMMENTS_REQUEST,
  SAVE_ACCOUNT_COMMENTS_SUCCESS,
  SAVE_ACCOUNT_COMMENTS_FAILURE,
  EDIT_ACCOUNT_NAME,
  EDIT_ACCOUNT_NAME_CANCEL,
  UPDATE_ACCOUNT_NAME_REQUEST,
  UPDATE_ACCOUNT_NAME_SUCCESS,
  UPDATE_ACCOUNT_NAME_ERROR,
  GET_ALL_CONTROLLING_PERSONS_REQUEST,
  GET_ALL_CONTROLLING_PERSONS_SUCCESS,
  GET_ALL_CONTROLLING_PERSONS_FAILURE,
  ADD_CONTROLLING_PERSON_REQUEST,
  ADD_CONTROLLING_PERSON_SUCCESS,
  ADD_CONTROLLING_PERSON_FAILURE,
  EXPIRE_CONTROLLING_PERSON_REQUEST,
  EXPIRE_CONTROLLING_PERSON_SUCCESS,
  EXPIRE_CONTROLLING_PERSON_FAILURE,
  REMOVE_CONTROLLING_PERSON_REQUEST,
  REMOVE_CONTROLLING_PERSON_SUCCESS,
  REMOVE_CONTROLLING_PERSON_FAILURE,
  GET_RC518_CONTROLLING_PERSONS_FORMS_REQUEST,
  GET_RC518_CONTROLLING_PERSONS_FORMS_SUCCESS,
  GET_RC518_CONTROLLING_PERSONS_FORMS_FAILURE,
  OPEN_LINK_IMY_STRUCTURE_CONFIRM_MODAL,
  CLOSE_LINK_IMY_STRUCTURE_CONFIRM_MODAL,
  LINK_ACCOUNT_TO_IMY_STRUCTURE_REQUEST,
  LINK_ACCOUNT_TO_IMY_STRUCTURE_SUCCESS,
  LINK_ACCOUNT_TO_IMY_STRUCTURE_FAILURE,
  WHS_LINK_OPERATION_STATUS_REQUEST,
  WHS_LINK_OPERATION_STATUS_SUCCESS,
  WHS_LINK_OPERATION_STATUS_FAILED,
  WHS_LINK_OPERATION_STATUS_RETRIES_FAILED,
  WHS_LINK_OPERATION_STATUS_LIST_REQUEST,
  WHS_LINK_OPERATION_STATUS_LIST_SUCCESS,
  WHS_LINK_OPERATION_STATUS_LIST_FAILED,
  GET_ACCOUNT_LINKED_IMY_STRUCTURE_REQUEST,
  GET_ACCOUNT_LINKED_IMY_STRUCTURE_SUCCESS,
  GET_ACCOUNT_LINKED_IMY_STRUCTURE_FAILURE,
  GET_ACCOUNT_LINKED_IMY_STRUCTURE_CLEAR
} from 'actions';

// eslint-disable-next-line default-param-last
function account(state = {
  storeAccount: null,
  isLoadingData: false,
  isAccountNumberChangeModalShown: false,
  isGettingAccounts: false,
  accounts: [],
  accountsCount: 0,
  isUnlinkFormModalShown: false,
  isUnlinkingForm: false,
  unlinkFormError: null,
  isUpdatingDualFormStatusShown: false,
  isSavingAccount: false,
  accountError: null,
  controllingPersons: null,
  isGettingControllingPersons: false,
  isLinkingControllingPerson: false,
  isLinkingControllingPersonComplete: false,
  isExpiringControllingPerson: false,
  isRemovingControllingPerson: false,
  isLinkWhsAccountConfirmModalShown: false,
  isGettingWhsLinkOperationStatus: false,
  accountWhsLinkStatus: null,
  accountWhsLinkMonitorFailed: false,
  isGettingWhsLinkStatuses: false,
  whsLinkStatuses: null,
  whsLinkMultiMonitorFailed: false,
  linkedImyStructure: null,
}, action) {
  switch (action.type) {
    case OPEN_UPDATE_DUAL_FORM_STATUS_MODAL:
    case CLOSE_UPDATE_DUAL_FORM_STATUS_MODAL:
      return {
        ...state,
        isUpdateDualFormStatusModalShown: action.showModal,
        dualFormCheckStatus: action.dualFormCheckStatus,
        dualFormSelectedAccountId: action.dualFormSelectedAccountId,
        dualFormSeletedAccountNumber: action.dualFormSeletedAccountNumber,
        updateDualFormStatusError: null
      };
    case REQUEST_UPDATE_DUAL_FORM_STATUS:
      return {
        ...state,
        isUpdatingDualFormStatus: true
      };
    case RECIEVE_UPDATE_DUAL_FORM_STATUS:
    case UPDATE_DUAL_FORM_STATUS_FAILURE:
      return {
        ...state,
        isUpdatingDualFormStatus: false,
        updateDualFormStatusError: action.updateDualFormStatusError,
      };
    case LOAD_ACCOUNT:
      return {
        ...state,
        isLoadingData: false,
        storeAccount: action.storeAccount
      };
    case LOAD_ACCOUNT_DATA:
      return {
        ...state,
        isLoadingData: true,
        storeAccount: null,
        accountDataLoadError: null
      };
    case LOAD_ACCOUNT_DATA_FAILURE:
      return {
        ...state,
        isLoadingData: false,
        accountDataLoadError: action.accountDataLoadError
      };
    case CLOSE_ACCOUNT_NUMBER_CHANGE_FORM_ERROR:
      return {
        ...state,
        isAccountNumberChangeModalShown: action.isAccountNumberChangeModalShown
      };
    case CLOSE_ACCOUNT_NUMBER_CHANGE_FORM_MODAL:
      return {
        ...state,
        isAccountNumberChangeModalShown: action.isAccountNumberChangeModalShown,
        returnedExistingAccountId: action.returnedExistingAccountId
      };
    case OPEN_ACCOUNT_NUMBER_CHANGE_FORM_MODAL:
      return {
        ...state,
        isAccountNumberChangeModalShown: action.isAccountNumberChangeModalShown
      };
    case ACCOUNT_NUMBER_CHANGE_CLEAR_REQUEST:
      return {
        ...state,
        returnedExistingAccountId: ''
      };
    case CLEAR_ACCOUNT_REQUEST:
      return {
        ...state,
        isLoadingData: false,
        storeAccount: null,
        isAccountNumberChangeModalShown: false
      };
    case GET_ACCOUNTS_REQUEST:
      return {
        ...state,
        isGettingAccounts: action.isGettingAccounts
      };
    case GET_ACCOUNTS_SUCCESS:
      return {
        ...state,
        isGettingAccounts: action.isGettingAccounts,
        accounts: action.accounts,
        accountsCount: action.accountsCount
      };
    case GET_ACCOUNTS_FAILURE:
      return {
        ...state,
        isGettingAccounts: action.isGettingAccounts
      };
    case OPEN_UNLINK_FORM_MODAL:
      return {
        ...state,
        isUnlinkFormModalShown: true,
        isUnlinkingForm: false,
        unlinkFormError: null
      };
    case CLOSE_UNLINK_FORM_MODAL:
      return {
        ...state,
        isUnlinkFormModalShown: false,
        isUnlinkingForm: false,
        unlinkFormError: null
      };
    case UNLINK_ACCOUNT_FORM_REQUEST:
      return {
        ...state,
        isUnlinkingForm: true,
        unlinkFormError: null
      };
    case UNLINK_ACCOUNT_FORM_SUCCESS:
      return {
        ...state,
        isUnlinkFormModalShown: false,
        isUnlinkingForm: false,
        unlinkFormError: null
      };
    case UNLINK_ACCOUNT_FORM_FAILURE:
      return {
        ...state,
        isUnlinkingForm: false,
        unlinkFormError: action.unlinkFormError
      };
    case SAVE_ACCOUNT_COMMENTS_REQUEST:
      return {
        ...state,
        isSavingAccount: action.isSavingAccount
      };
    case SAVE_ACCOUNT_COMMENTS_SUCCESS:
      if (state.storeAccount) {
        if (!state.storeAccount.previousComments) {
          state.storeAccount.previousComments = [];
        }
        state.storeAccount.previousComments.push(action.savedComment);
        state.storeAccount.newComment = '';
      }

      return {
        ...state,
        isSavingAccount: action.isSavingAccount,
        account: Object.assign(state.storeAccount, {}),
        accountError: action.accountError
      };
    case SAVE_ACCOUNT_COMMENTS_FAILURE:
      return {
        ...state,
        isSavingAccount: action.isSavingAccount,
        accountError: action.accountError
      };
    case EDIT_ACCOUNT_NAME:
      return {
        ...state,
        isEditingAccount: true
      };
    case EDIT_ACCOUNT_NAME_CANCEL:
      return {
        ...state,
        isEditingAccount: false
      };
    case UPDATE_ACCOUNT_NAME_REQUEST:
      return {
        ...state,
        isEditingAccount: true
      };
    case UPDATE_ACCOUNT_NAME_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const { storeAccount } = state;
      storeAccount.accountName = action.accountName;

      return {
        ...state,
        storeAccount,
        isEditingAccount: false,
        isSubmittingAccount: false
      };
    case UPDATE_ACCOUNT_NAME_ERROR:
      return {
        ...state,
        isEditingAccount: true,
        isSubmittingAccount: false
      };
    case GET_ALL_CONTROLLING_PERSONS_REQUEST:
      return {
        ...state,
        isGettingControllingPersons: true
      };
    case GET_ALL_CONTROLLING_PERSONS_SUCCESS:
      return {
        ...state,
        controllingPersons: action.controllingPersons,
        isGettingControllingPersons: false,
      };
    case GET_ALL_CONTROLLING_PERSONS_FAILURE:
      return {
        ...state,
        isGettingControllingPersons: false,
      };
    case ADD_CONTROLLING_PERSON_REQUEST:
      return {
        ...state,
        isLinkingControllingPerson: true,
        isLinkingControllingPersonComplete: false,
      };
    case ADD_CONTROLLING_PERSON_SUCCESS:
      return {
        ...state,
        controllingPersons: action.controllingPersons,
        isLinkingControllingPerson: false,
        isLinkingControllingPersonComplete: true,
      };
    case ADD_CONTROLLING_PERSON_FAILURE:
      return {
        ...state,
        isLinkingControllingPerson: false,
        isLinkingControllingPersonComplete: false,
      };
    case EXPIRE_CONTROLLING_PERSON_REQUEST:
      return {
        ...state,
        isExpiringControllingPerson: true,
      };
    case EXPIRE_CONTROLLING_PERSON_SUCCESS:
      return {
        ...state,
        isExpiringControllingPerson: false,
      };
    case EXPIRE_CONTROLLING_PERSON_FAILURE:
      return {
        ...state,
        isExpiringControllingPerson: false,
      };
    case REMOVE_CONTROLLING_PERSON_REQUEST:
      return {
        ...state,
        isRemovingControllingPerson: true,
      };
    case REMOVE_CONTROLLING_PERSON_SUCCESS:
      return {
        ...state,
        isRemovingControllingPerson: false,
      };
    case REMOVE_CONTROLLING_PERSON_FAILURE:
      return {
        ...state,
        isRemovingControllingPerson: false,
      };
    case GET_RC518_CONTROLLING_PERSONS_FORMS_REQUEST:
      return {
        ...state,
        isGettingAccountRc519CpForms: true
      };
    case GET_RC518_CONTROLLING_PERSONS_FORMS_SUCCESS:
      return {
        ...state,
        storeAccount: {
          ...state.storeAccount,
          rc518CpForms: action.rc518CpForms
        },
        isGettingAccountRc519CpForms: false
      };
    case GET_RC518_CONTROLLING_PERSONS_FORMS_FAILURE:
      return {
        ...state,
        storeAccount: {
          ...state.storeAccount,
          rc518CpForms: null
        },
        isGettingAccountRc519CpForms: false
      };
    case OPEN_LINK_IMY_STRUCTURE_CONFIRM_MODAL:
      return {
        ...state,
        isLinkToImyStructureConfirmModalShown: true,
        targetWhsLinkAccount: action.targetWhsLinkAccount
      };
    case CLOSE_LINK_IMY_STRUCTURE_CONFIRM_MODAL:
      return {
        ...state,
        isLinkToImyStructureConfirmModalShown: false,
        targetWhsLinkAccount: null
      };
    case LINK_ACCOUNT_TO_IMY_STRUCTURE_REQUEST:
      return {
        ...state,
        isLinkToImyStructureConfirmModalShown: false,
        isLinkingToImyStructureModalShown: true
      };
    case LINK_ACCOUNT_TO_IMY_STRUCTURE_SUCCESS:
      return {
        ...state,
        isLinkingToImyStructureModalShown: action.isLinkingToImyStructureModalShown,
      };
    case LINK_ACCOUNT_TO_IMY_STRUCTURE_FAILURE:
      return {
        ...state,
        isLinkingToImyStructureModalShown: false,
        targetWhsLinkAccount: null
      };
    case WHS_LINK_OPERATION_STATUS_REQUEST:
      return {
        ...state,
        isGettingWhsLinkOperationStatus: action.isGettingWhsLinkOperationStatus
      };
    case WHS_LINK_OPERATION_STATUS_SUCCESS:
      return {
        ...state,
        isGettingWhsLinkOperationStatus: action.isGettingWhsLinkOperationStatus,
        accountWhsLinkStatus: action.accountWhsLinkStatus,
        isLinkingToImyStructureModalShown: action.isLinkingToImyStructureModalShown,
        targetWhsLinkAccount: { ...state.targetWhsLinkAccount, id: action.accountWhsLinkStatus.toAccountId },
        accountWhsLinkMonitorFailed: false
      };
    case WHS_LINK_OPERATION_STATUS_FAILED:
      return {
        ...state,
        isGettingWhsLinkOperationStatus: action.isGettingWhsLinkOperationStatus
      };
    case WHS_LINK_OPERATION_STATUS_RETRIES_FAILED:
      return {
        ...state,
        accountWhsLinkMonitorFailed: true
      };
    case WHS_LINK_OPERATION_STATUS_LIST_REQUEST:
      return {
        ...state,
        isGettingWhsLinkStatuses: false,
        whsLinkMultiMonitorFailed: false
      };
    case WHS_LINK_OPERATION_STATUS_LIST_SUCCESS:
      return {
        ...state,
        isGettingWhsLinkStatuses: false,
        whsLinkStatuses: action.whsLinkStatuses,
        whsLinkMultiMonitorFailed: false
      };
    case WHS_LINK_OPERATION_STATUS_LIST_FAILED:
      return {
        ...state,
        isGettingWhsLinkStatuses: false,
        whsLinkStatuses: null,
        whsLinkMultiMonitorFailed: true
      };
    case GET_ACCOUNT_LINKED_IMY_STRUCTURE_REQUEST:
      return {
        ...state
      };
    case GET_ACCOUNT_LINKED_IMY_STRUCTURE_SUCCESS:
      return {
        ...state,
        linkedImyStructure: action.linkedImyStructure
      };
    case GET_ACCOUNT_LINKED_IMY_STRUCTURE_FAILURE:
      return {
        ...state,
        linkedImyStructure: null
      };
    case GET_ACCOUNT_LINKED_IMY_STRUCTURE_CLEAR:
      return {
        ...state,
        linkedImyStructure: null
      };
    default:
      return state;
  }
}

export default account;
